enum USER_LEVELS {
  BASIC = 'basic',
  DETAILED = 'detailed',
  MANAGING = 'managing',
}

export default USER_LEVELS;
